import { ON_HOLD } from 'constants/cookies'

interface OnHoldBannerQueryInput {
  isAuthPending: boolean
  isLoggedIn: boolean
  isSubscriberFlagPending: boolean
  isOnHoldSubscriber: boolean | undefined
  isSiteDataPending: boolean
  hasOnHoldBanner: boolean | undefined
  allAccessStatus: string | undefined
  aiStatus: string | undefined
}

const ON_HOLD_VALUES = new Set(Object.values(ON_HOLD))

function isOnHold(value: string | undefined) {
  return Boolean(value && ON_HOLD_VALUES.has(value))
}

export function resolveOnHoldBannerQuery({
  isAuthPending,
  isLoggedIn,
  isSubscriberFlagPending,
  isOnHoldSubscriber,
  isSiteDataPending,
  hasOnHoldBanner,
  allAccessStatus,
  aiStatus,
}: OnHoldBannerQueryInput) {
  return {
    isPending: isAuthPending || isSubscriberFlagPending || (isLoggedIn && isSiteDataPending),
    data: Boolean(
      isOnHoldSubscriber || hasOnHoldBanner || isOnHold(allAccessStatus) || isOnHold(aiStatus),
    ),
  }
}
